import React from "react";
import { Dashboard as DashboardLayout } from "../../../layouts/";
import { TaskUsageContent, TaskUsagePreview } from "./VoiceHubWidgets/IntentUsage";
import { Dashboard, Widget, Config, Content } from "../dashboard";
import { UniqueUsersContent, UniqueUsersPreview } from "./VoiceHubWidgets/UniqueUsers";
import { PeakUsageTimeContent, PeakUsageTimePreview } from "./VoiceHubWidgets/PeakUsageTime";
import { ExitPercentAlexaContent, ExitPercentAlexaPreview, ExitPercentConfig } from "./VoiceHubWidgets/ExitPercent";
import { connect } from "react-redux";
import {
  UserInteractionContent,
  UserInteractionPreview,
  UserInteractionConfig
} from "./VoiceHubWidgets/UserInteraction";
import { UncompletedReqInTotalContent, UncompletedReqInTotalPreview } from "./VoiceHubWidgets/UncompletedRequestsTotal";
import {
  UncompletedRequestsByIntentContent,
  UncompletedRequestsByIntentPreview
} from "./VoiceHubWidgets/UncompletedRequestsByIntent";
import {
  UncompletedRequestsByUserContent,
  UncompletedRequestsByUserPreview
} from "./VoiceHubWidgets/UncompletedRequestsByUser";
import RightSidebarDetails from "../../../layouts/Dashboard/components/RightSidebarDetails";
import FromToDate from "../dashboard/FromToDateComponent";
import { withStyles } from "@material-ui/core";
import { UniqueSessionsContent, UniqueSessionsPreview } from "./VoiceHubWidgets/UniqueSessions";
import { UniqueSessionsByUserContent, UniqueSessionsByUserPreview } from "./VoiceHubWidgets/UniqueSessionsByUser";
import {
  AVGNumberOfUtterancesPerSessionContent,
  AVGNumberOfUtterancesPerSessionPreview
} from "./VoiceHubWidgets/UniqueSessioinsAVGNumberOfUtterances";
import {
  RequestByPlatformPublicContent,
  RequestByPlatformPublicPreview
} from "./VoiceHubWidgets/RequestByPlatformPublic";
import { UsageSummaryContent, UsageSummaryPreviewStyled } from "./VoiceHubWidgets/UsageSummary";
import { LexPlatformUsageContent, LexPlatformUsagePreview } from "./VoiceHubWidgets/LexPlatformUsage";
import { UsageByConnectorContent, UsageByConnectorPreview } from "./VoiceHubWidgets/UsageByConnector";
import { updateFromToDate } from "../../../redux/actions/dashboardActions";
import { bindActionCreators } from "redux";
import _ from "lodash";

const styles = {
  pickerContainer: {
    margin: "auto",
    marginTop: "20px",
    marginBottom: "20px",
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-around"
  }
};

class DashboardExample extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.cognitoUser.username != "user") {
      this.state = {
        editMode: false,
        moveMode: false,
        config: [
          { widgetId: "usage_summary", instanceId: "1" },
          { widgetId: "unique_users_in_total", instanceId: "2" },
          { widgetId: "unique_sessions_in_total", instanceId: "3" },
          { widgetId: "usage_by_task", instanceId: "4" },
          {
            widgetId: "user_interaction_admin",
            instanceId: "5",
            config: { platform: "portal" }
          },
          { widgetId: "lex_platform_usage", instanceId: "6" }
        ],
        rightSidebarIsOpen: false,
        detailData: {
          contentType: undefined,
          data: undefined
        }
      };
    } else {
      this.state = {
        editMode: false,
        moveMode: false,
        config: [{ widgetId: "unique_users_in_total", instanceId: "3" }],
        rightSidebarIsOpen: false,
        detailData: {
          contentType: undefined,
          data: undefined
        }
      };
    }
  }

  componentDidMount() {
    const savedObj = localStorage.getItem("dashboardUserPreferences");

    let dashboardUserPreferences = savedObj === null ? null : window.atob(savedObj);

    const username = this.props.cognitoUser.username;

    if (
      dashboardUserPreferences &&
      dashboardUserPreferences != "null" &&
      JSON.parse(dashboardUserPreferences).dashboard[username]
    ) {
      const loaded = JSON.parse(dashboardUserPreferences).dashboard[username];
      this.setState({ config: loaded.config });
      this.setState({ ui: loaded.ui });
      if (loaded.ui && loaded.ui.dashboardDates && loaded.ui.dashboardDatesUpdated) {
        // reset date after 7 days from last period change
        const dataValidAfter = Math.floor(Date.now() / 1000) - 60 * 60 * 24 * 7;
        if (loaded.ui.dashboardDatesUpdated > dataValidAfter) this.props.updateFromToDate(loaded.ui.dashboardDates);
      }
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.dashboardDates) {
      const newState = { initDashboardDates: nextProps.dashboardDates };
      if (this.state.initDashboardDates) {
        if (
          nextProps.dashboardDates.fromDate !== this.state.initDashboardDates.fromDate ||
          nextProps.dashboardDates.toDate !== this.state.initDashboardDates.toDate
        ) {
          console.log(nextProps.dashboardDates);
          // new value only on change
          let stateDashboardDates = _.pick(nextProps.dashboardDates, [
            "fromDate",
            "toDate",
            "fromDateISO",
            "toDateISO"
          ]);
          newState.ui = {
            ...this.state.ui,
            dashboardDates: stateDashboardDates,
            dashboardDatesUpdated: Math.floor(Date.now() / 1000)
          };
        } else {
          newState.ui = {
            ...this.state.ui,
            dashboardDatesUpdated: Math.floor(Date.now() / 1000)
          };
        }
      }
      this.setState(newState);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const username = this.props.cognitoUser.username;
    const state = {
      dashboard: {
        [username]: {
          config: this.state.config,
          ui: this.state.ui
        }
      }
    };

    const savedObj = localStorage.getItem("dashboardUserPreferences");

    const oldObject = savedObj === null ? null : window.atob(savedObj);

    let finalObject;

    if (oldObject !== null) {
      finalObject = JSON.parse(oldObject);
      finalObject.dashboard[username] = state.dashboard[username];
    } else {
      finalObject = state;
    }

    // window.localStorage.setItem("dashboardUserPreferences", oldObject !== null ? window.btoa(JSON.stringify(_.update(JSON.parse(oldObject), "dashboard." + username, state.dashboard[username]))) : window.btoa(JSON.stringify(state)))
    window.localStorage.setItem("dashboardUserPreferences", window.btoa(JSON.stringify(finalObject)));
  }

  toggleMoveMode = () => {
    this.setState(prevState => ({
      moveMode: !this.state.moveMode,
      editMode: prevState.editMode ? false : false
    }));
  };

  toggleEditMode = () => {
    const newEditMode = !this.state.editMode;
    console.log(this.state.editMode);
    this.setState(prevState => ({
      editMode: newEditMode,
      moveMode: prevState.moveMode ? false : false
    }));
  };

  toggleRightSidebar = e => {
    this.setState({
      rightSidebarIsOpen: !this.state.rightSidebarIsOpen
    });
  };

  updateDetailData = data => {
    this.setState({
      detailData: data
    });
  };

  displayName() {
    return "ExampleDashboard";
  }

  configChange = newConfig => {
    this.setState({ config: newConfig });
  };

  render() {
    const { moveMode, editMode } = this.state;
    const { classes, sidebarIsOpen, rightSidebarIsOpen } = this.props;

    return (
      <DashboardLayout title="Dashboard">
        <div className={classes.pickerContainer}>
          <FromToDate
            toggleMoveMode={this.toggleMoveMode}
            toggleEditMode={this.toggleEditMode}
            editMode={this.state.editMode}
            moveMode={this.state.moveMode}
          />
        </div>
        <RightSidebarDetails
          rightSidebarIsOpen={this.state.rightSidebarIsOpen}
          toggleRightSidebar={this.toggleRightSidebar}
          detailProps={{
            contentType: this.state.detailData.contentType,
            data: this.state.detailData
          }}
        />
        {this.props.cognitoUser.username != "jbosnjakovic@iolap.com1" ? (
          <Dashboard
            className="example-dash"
            title="Dashboard Title"
            config={this.state.config}
            onConfigChange={this.configChange}
            widgetHeight={250}
            widgetWidth={250}
            widgetMargin={15}
            titleHeight={50}
            sidebarIsOpen={sidebarIsOpen}
            rightSidebarIsOpen={rightSidebarIsOpen}
            doneButtonClass="btn btn-primary"
            moveMode={moveMode}
            editMode={editMode}
          >
            <Widget
              id="usage_summary"
              width="2"
              contentComp={UsageSummaryContent}
              previewComp={UsageSummaryPreviewStyled}
            />
            <Widget
              id="usage_by_connector"
              width="2"
              contentComp={UsageByConnectorContent}
              previewComp={UsageByConnectorPreview}
            />
            <Widget id="usage_by_task" width="2" contentComp={TaskUsageContent} previewComp={TaskUsagePreview} />
            <Widget
              id="unique_users_in_total"
              width="1"
              contentComp={UniqueUsersContent}
              previewComp={UniqueUsersPreview}
            />
            <Widget
              id="user_interaction_admin"
              width="2"
              contentComp={UserInteractionContent}
              previewComp={UserInteractionPreview}
              configComp={UserInteractionConfig}
            />
            <Widget
              id="lex_platform_usage"
              width="2"
              contentComp={LexPlatformUsageContent}
              previewComp={LexPlatformUsagePreview}
            />
            <Widget
              id="unique_sessions_in_total"
              width="1"
              contentComp={UniqueSessionsContent}
              previewComp={UniqueSessionsPreview}
            />
            <Widget
              id="unique_sessions_by_user"
              width="2"
              contentComp={UniqueSessionsByUserContent}
              previewComp={UniqueSessionsByUserPreview}
            />
            {/* <Widget
              id="avg_number_of_utt_per_session"
              width="2"
              contentComp={AVGNumberOfUtterancesPerSessionContent}
              previewComp={AVGNumberOfUtterancesPerSessionPreview}
              toggleRightSidebar={this.toggleRightSidebar}
              updateDetailData={this.updateDetailData}
            /> */}
            {/* <Widget
              id="peak_usage_time"
              width="3"
              contentComp={PeakUsageTimeContent}
              previewComp={PeakUsageTimePreview}
            /> */}
            {/* <Widget
              id="exit_percent"
              width="2"
              contentComp={ExitPercentAlexaContent}
              previewComp={ExitPercentAlexaPreview}
              configComp={ExitPercentConfig}
            /> */}
            {/* <Widget
              id="uncompleted_requests_in_total"
              width="1"
              contentComp={UncompletedReqInTotalContent}
              previewComp={UncompletedReqInTotalPreview}
            /> */}
            <Widget
              id="sessions_by_platform_public_user"
              width="2"
              contentComp={RequestByPlatformPublicContent}
              previewComp={RequestByPlatformPublicPreview}
            />
            {/* <Widget
              id="uncompleted_requests_by_intent"
              width="2"
              contentComp={UncompletedRequestsByIntentContent}
              previewComp={UncompletedRequestsByIntentPreview}
              toggleRightSidebar={this.toggleRightSidebar}
              updateDetailData={this.updateDetailData}
            /> */}
            {/* <Widget
              id="uncompleted_requests_by_user"
              width="2"
              contentComp={UncompletedRequestsByUserContent}
              previewComp={UncompletedRequestsByUserPreview}
              toggleRightSidebar={this.toggleRightSidebar}
              updateDetailData={this.updateDetailData}
            /> */}
            {/*<Dialog open={this.state.DialogOpen} handleDialogClose={this.handleDialogClose} />*/}
            {/*<Widget*/}
            {/*  id="accident"*/}
            {/*  contentComp={() => (*/}
            {/*    <div className="days-since-last">*/}
            {/*      <div className="days">13</div>*/}
            {/*      <div className="text">days since last accident</div>*/}
            {/*    </div>*/}
            {/*  )}*/}
            {/*  previewComp={() => (*/}
            {/*    <div className="days-since-last preview">*/}
            {/*      <div className="days">100</div>*/}
            {/*      <div className="text">days since last accident</div>*/}
            {/*    </div>*/}
            {/*  )}*/}
            {/*/>*/}
            {/*<Widget*/}
            {/*  id="weather"*/}
            {/*  contentComp={WeatherWidgetContent}*/}
            {/*  configComp={WeatherWidgetConfig}*/}
            {/*  previewComp={WeatherWidgetPreview}*/}
            {/*/>*/}
            {/*<Widget id="pie" contentComp={pieChart.Content} previewComp={pieChart.Preview} />*/}
            {/*<Widget id="barChart" width="2" contentComp={barChart.Content} />*/}
            {/*<Widget id="thumbsUp" contentComp={booleanWidget.Content} previewComp={booleanWidget.Preview} />*/}
            {/*<Widget id="nothin" width="2" />*/}
            {/*<Widget id="anotherEmpty" />*/}
            {/*<Widget id="activityLog" height="2" contentComp={activityWidget.Content} />*/}
            {/*<Widget id="empty" />*/}
            {/*<Widget id="wideEmpty" width="2" />*/}
          </Dashboard>
        ) : (
          <Dashboard
            className="example-dash"
            title="Dashboard Title"
            config={this.state.config}
            onConfigChange={this.configChange}
            widgetHeight={250}
            widgetWidth={250}
            widgetMargin={15}
            titleHeight={50}
            sidebarIsOpen={sidebarIsOpen}
            rightSidebarIsOpen={rightSidebarIsOpen}
            doneButtonClass="btn btn-primary"
            moveMode={moveMode}
            editMode={editMode}
          >
            <Widget id="usage_by_task" width="2" contentComp={TaskUsageContent} previewComp={TaskUsagePreview} />
            <Widget
              id="unique_users_in_total"
              width="1"
              contentComp={UniqueUsersContent}
              previewComp={UniqueUsersPreview}
              handleDialogOpen={this.handleDialogOpen}
            />
            {/*<Dialog open={this.state.DialogOpen} handleClose={this.handleDialogClose} />*/}
          </Dashboard>
        )}
      </DashboardLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    dashboardDates: state.dashboard.widgetFromToDate,
    sidebarIsOpen: state.layout.sidebarIsOpen,
    rightSidebarIsOpen: state.layout.rightSidebarIsOpen,
    cognitoUser: state.auth.cognitoUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        updateFromToDate
      },
      dispatch
    ),
    dispatch
  };
}

DashboardExample = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardExample);

export default withStyles(styles)(DashboardExample);
